import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {CreateEditModal} from '../../shared/components';
import {EditUserForm} from '../components';
import {getEditUserModalValidationErrors} from '../selectors';
import {mapSelectedOptionsToValues} from '../../shared/services';
import toastr from 'toastr';
import {cancelEditUser, setEditUserProperty, updateUser} from '../actions/creators';
import {List, Map} from 'immutable';
import React, {Component, PropTypes} from 'react';

class EditUserModal extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  handleFieldChange(event) {
    if (event.target.tagName === 'SELECT') {
      this.handleSelectFieldChange(event);
    } else {
      this.handleInputFieldChange(event);
    }
  }

  handleSelectFieldChange(event) {
    const {name, options} = event.target;
    this.props.handleFieldChange(name, mapSelectedOptionsToValues(options));
  }

  handleInputFieldChange(event) {
    const {name, value} = event.target;
    this.props.handleFieldChange(name, value);
  }

  handleSave(event) {
    event.preventDefault();

    const {handleSave, user} = this.props;
    handleSave(user)
      .catch(error => {
        if (error.response && error.response.status === 400) return;
        toastr.error('An error occurred while attempting to update this user.', 'Error');
        throw error;
      });
  }

  render() {
    const {handleCancel, loading, saving, show, user, validationErrors} = this.props;

    const form =
      <EditUserForm
        loading={loading}
        saving={saving}
        onFieldChange={this.handleFieldChange}
        onSubmit={this.handleSave}
        validationErrors={validationErrors}
        user={user} />;

    return (
      <CreateEditModal
        show={show}
        loading={loading}
        saving={saving}
        title="Edit User"
        form={form}
        onCancel={handleCancel}
        onSave={this.handleSave} />
    );
  }
}

EditUserModal.propTypes = {
  handleCancel: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleSave: PropTypes.func,
  loading: PropTypes.bool,
  saving: PropTypes.bool,
  show: PropTypes.bool,
  user: PropTypes.instanceOf(Map),
  validationErrors: PropTypes.instanceOf(List)
};

function mapStateToProps(state) {
  const {editUser} = state.features.users.modals;

  return {
    loading: editUser.get('loading'),
    saving: editUser.get('saving'),
    show: editUser.get('show'),
    user: editUser.get('user'),
    validationErrors: getEditUserModalValidationErrors(state)
  };
}

export default connect(
  mapStateToProps,
  {
    handleCancel: cancelEditUser,
    handleFieldChange: setEditUserProperty,
    handleSave: updateUser,
  }
)(EditUserModal);



// WEBPACK FOOTER //
// ./app/features/users/containers/EditUserModal.js